import { createSlice } from "@reduxjs/toolkit";
import { ReactNode } from "react";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";

export class Certificate {
    serialNumber = "";
    commonName = "";
    certificateHex = "";
    issuer = "";
    notAfter = "";
    notBefore = "";
    subjectCommonName = "";
    subjectSerialNumber = "";
    errorMessage = "";
};

export class SmartCard {
    slotId: string = "";
    library: string = "";
    terminal: string = "";
    certificates: Certificate[] = [];
    certificateInquired: boolean = false;
};
export class SmartCardandCertificateList {
    smartCards: SmartCard[] = [];
    currentSmartCard: number = 1;
    smartCardLength: number = 0;
};
interface IEImzaState {
    errorCard: string | ReactNode,
    loadingCard: boolean,
    errorCertificate: string,
    loadingCertificate: boolean,
    smartCardandCertificateList: SmartCardandCertificateList,
    open: boolean,
    errorSign: string,
    smartCard: SmartCard,
    certificate: Certificate,
    pin: string
}

export var EimzaInitialState = {
    errorCard: "",
    loadingCard: false,
    errorCertificate: "",
    loadingCertificate: false,
    smartCardandCertificateList: new SmartCardandCertificateList(),
    open: false,
    errorSign: "",
    smartCard: new SmartCard(),
    certificate: new Certificate()
}
const EImzaSlice = createSlice<IEImzaState, MapReducerPayloads<IEImzaState, {
    setState: IEImzaState
}>>({
    name: 'eImza',
    initialState: {
        ...EimzaInitialState,
        pin: ""
    },
    reducers: {
        setState: (state, action) => action.payload
    }
})
export default EImzaSlice;